import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Mail, X } from 'lucide-react';

const TARGET_PATHS = ['/app/tests', '/app/interview-assistant', '/app/psych-tests', '/app/psychodiagnostics'];

const FixedTestRequestBar: React.FC = () => {
  const location = useLocation();
  const [dismissed, setDismissed] = useState(false);

  // При смене маршрута сбрасываем dismissed для целевых страниц
  useEffect(() => {
    setDismissed(false);
  }, [location.pathname]);

  const isTarget = TARGET_PATHS.some(path => location.pathname.startsWith(path));
  if (!isTarget || dismissed) return null;

  return (
    <div style={styles.bar}>
      <span style={styles.text}>
        🔍 Не нашли подходящий тест? Напишите администратору – мы добавим нужные тесты в ближайшем обновлении.
      </span>
      <a href="mailto:info@hrlama.ru" style={styles.emailBtn}>
        <Mail size={14} /> info@hrlama.ru
      </a>
      <button onClick={() => setDismissed(true)} style={styles.closeBtn}>
        <X size={16} />
      </button>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  bar: {
    position: 'fixed',
    bottom: 20,
    left: '50%',
    transform: 'translateX(-50%)',
    width: 'auto',
    maxWidth: '90%',
    background: 'rgba(255, 255, 255, 0.85)',
    backdropFilter: 'blur(20px)',
    borderRadius: '20px',
    padding: '14px 24px',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    boxShadow: '0 15px 35px rgba(0,0,0,0.1), 0 0 0 1px rgba(255,255,255,0.3) inset',
    border: '1px solid rgba(255,255,255,0.5)',
    zIndex: 10000,
    fontSize: '14px',
    flexWrap: 'wrap',
    justifyContent: 'center',
    animation: 'fadeInUp 0.4s ease',
  },
  text: { color: '#1a1a2e', fontWeight: 500, textAlign: 'center', flex: 1, minWidth: '200px' },
  emailBtn: {
    display: 'inline-flex', alignItems: 'center', gap: '6px',
    padding: '8px 18px', borderRadius: '30px',
    background: 'linear-gradient(135deg, #6a11cb, #2575fc)',
    color: 'white', textDecoration: 'none', fontSize: '13px', fontWeight: 600,
    boxShadow: '0 4px 12px rgba(37,117,252,0.3)',
    transition: 'all 0.2s',
  },
  ticketBtn: {
    display: 'inline-flex', alignItems: 'center', gap: '6px',
    padding: '8px 18px', borderRadius: '30px',
    border: '1px solid #2575fc', background: 'transparent', color: '#2575fc',
    fontSize: '13px', fontWeight: 600, cursor: 'pointer',
    transition: 'all 0.2s',
  },
  closeBtn: {
    background: 'rgba(255,255,255,0.5)',
    backdropFilter: 'blur(4px)',
    border: '1px solid rgba(0,0,0,0.1)',
    borderRadius: '50%',
    width: '28px', height: '28px',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    cursor: 'pointer', color: '#4a4a68',
  },
};

export default FixedTestRequestBar;
